import React, { useEffect, useState } from 'react';

import UserAdminModalBase from '../UserAdminModalBase';
import { callFirebaseFunction } from '../../../utils/helpers';

function DirectoryUsersModal({ open, toggleModal, directoryId, directoryName, organizationId }) {
	const [users, setUsers] = useState([]);
	const [loading, setLoading] = useState(false);

	const fetchUsers = async () => {
		if (!directoryId || !organizationId) return;
		setLoading(true);
		try {
			const fetchedUsers = await callFirebaseFunction('getUsersForDirectory', { 
				directoryId,
				organizationId
			});
			setUsers(fetchedUsers);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (open && directoryId) {
			fetchUsers();
		}
	}, [open, directoryId]);

	const deleteUser = async (user) => {
		try {
			setLoading(true);
			await callFirebaseFunction('removeUserFromDirectory', { 
				email: user.email, 
				directoryId,
				organizationId 
			});
			fetchUsers();
		} catch {
			setLoading(false);
		}
	};

	const addNewUser = async (email) => {
		setLoading(true);
		try {
			await callFirebaseFunction('addUserToDirectory', { 
				email, 
				directoryId,
				organizationId 
			});
			fetchUsers();
		} catch {
			setLoading(false);
		}
	};

	return (
		<UserAdminModalBase
			users={users}
			open={open}
			toggleModal={toggleModal}
			updateOrDeleteUser={deleteUser}
			type="users"
			addNewUser={addNewUser}
			loading={loading}
			title={`Users with Access to ${directoryName || 'Directory'}`}
			description="Manage who has access to this directory and its projects."
		/>
	);
}

export default DirectoryUsersModal;
